import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  createLocationFailure, 
} from '../actions';
import { fetchUserLocations } from './fetchUserLocations';

// Initiator for setting the default location
export const asyncSetDefaultLocation = (locationId: string) => {
  return async (dispatch: Dispatch | any, getState: () => ReduxState) => {
    try {
      const { auth, user } = getState();
      const loginToken = auth.loginToken;
      const userId = user.user?._id

      const headers = {
        'X-Auth-Token': loginToken,
      };

      const response = await backend.put(
        `/user-service/api/v1/locations/user/set-default/${userId}/${locationId}`, 
        {}, { headers });
      
      if (response.status === 200) {
        if (userId) {
          dispatch(fetchUserLocations(userId));
        } 
      }
    } catch (error) {
      console.error('Failed to set default user location:', error);
      dispatch(createLocationFailure('An error occurred while setting default user location.'));
    }
  };
};